module.exports = __webpack_public_path__ + "static/img/cs_logo.50cfc05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cs_logo.png
// module id = Yu6E
// module chunks = 1